import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ControlErrorDirective } from '../../../shared/directive/control-error.directive';
import { InputText } from 'primeng/inputtext';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BaseFormComponent } from '../../../core/components/base-form.component';
import { AuthDevelopersFormBuilder } from './form-group/auth-developers.form.builder';
import { AuthDevelopersFormModel } from './form-group/auth-developers-form.model';
import { Button } from 'primeng/button';
import { FormsUtils } from '../../../shared/utils/forms.utils';
import { AuthService } from '../../../core/services/auth.service';
import { SpinnerService } from '../../../core/services/spinner.service';
import { Router } from '@angular/router';
import { APP_PATHS } from '../../../core/config/app-paths';

@Component({
  selector: 'app-auth-developers',
  imports: [ControlErrorDirective, InputText, ReactiveFormsModule, Button],
  templateUrl: './auth-developers.html',
  styleUrl: './auth-developers.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthDevelopers extends BaseFormComponent<AuthDevelopersFormModel> {
  readonly #router = inject(Router);
  readonly #authService = inject(AuthService);
  readonly #spinnerService = inject(SpinnerService);

  protected override createFormGroup(): FormGroup<AuthDevelopersFormModel> {
    return AuthDevelopersFormBuilder.createFormGroup();
  }

  protected login(): void {
    FormsUtils.markAllControlsAsTouchedAndDirty(
      Object.values(this.formGroup().controls),
    );
    if (this.formGroup().valid) {
      this.#spinnerService.show();
      const username = this.formGroup().controls.username.value!;
      const password = this.formGroup().controls.password.value!;
      this.#authService.signInByLogin(username, password);
    }
  }

  protected navigateToLoginMethod(): void {
    this.#router.navigate([APP_PATHS.auth.root, APP_PATHS.auth.loginMethod]);
  }
}
